import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFireDatabase } from '@angular/fire/database';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  public customOptions: OwlOptions = {
    loop: true,
    nav: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 1000,
    margin: 10,
    autoplay: true,
    navText: ['', ''],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };

  public projectsList = [
    {
      name: 'Você Não Está Sozinho',
      img: '../../assets/img/companies/vocenaoestasozinho.png',
      link: 'https://vocenaoestasozinho.com.br/',
      tech: [
        '../../assets/img/skills/html.svg',
        '../../assets/img/skills/css.svg',
        '../../assets/img/skills/javascript.svg',
        '../../assets/img/skills/php.svg',
      ],
      descriptionEN: "This is a social project I created to support suicide prevention. It's an app that provides helpful information and emotional support. The website was built using HTML, CSS, and JavaScript, and the mobile apps were developed with React Native using Expo. I also handled the entire backend, using Node.js with a Knex database. In addition, I personally set up the cloud infrastructure on AWS, hosting it via S3 and configuring all the required services to run the system in a production environment.",
      descriptionPT: "Projeto social de minha autoria, criado com o objetivo de ajudar na prevenção do suicídio. Trata-se de um aplicativo que oferece informações e suporte emocional. O site foi desenvolvido com HTML, CSS e JavaScript, e os aplicativos móveis foram criados com React Native usando Expo. Também fui responsável por toda a parte de backend, utilizando Node.js com banco de dados em Knex. Além disso, toda a infraestrutura foi configurada por mim na AWS, incluindo hospedagem no S3 e os serviços necessários para rodar a aplicação em ambiente de produção."
    },
    {
      name: 'Helpper',
      img: '../../assets/img/companies/helpper.png',
      link: 'https://helpper.com.br/',
      tech: [
        '../../assets/img/skills/html.svg',
        '../../assets/img/skills/css.svg',
        '../../assets/img/skills/javascript.svg',
        '../../assets/img/skills/git.svg',
      ],
      descriptionEN: "Project developed while working at the company, where I built the institutional website based on the Figma design using HTML, CSS, and JavaScript.",
      descriptionPT: "Projeto desenvolvido enquanto trabalhava na empresa, onde criei o site institucional com base no design do Figma utilizando HTML, CSS e JavaScript."
    },
    {
      name: 'Smart Milk Run',
      img: '../../assets/img/companies/smart-mil-run.webp',
      link: 'https://play.google.com/store/apps/details?id=br.com.atmtec.smartmilkrun&hl=pt_BR&gl=US',
      tech: ['../../assets/img/skills/flutter.svg'],
      descriptionEN: "Flutter app developed for a cargo transport company with dynamic route integration; I was fully responsible for the frontend, from architecture setup to deployment on both Play Store and App Store, applying design patterns and scalability best practices.",
      descriptionPT: "Aplicativo desenvolvido em Flutter para uma empresa de transporte de cargas, com integração de rotas dinâmicas; atuei 100% no frontend, desde a definição da arquitetura até a publicação nas lojas (Play Store e App Store), utilizando padrões de projeto e boas práticas de escalabilidade."
    },
    {
      name: 'Carneada',
      img: '../../assets/img/companies/logo-carneada.png',
      link: 'https://carneada.com.br/',
      tech: [
        '../../assets/img/skills/html.svg',
        '../../assets/img/skills/css.svg',
        '../../assets/img/skills/javascript.svg',
        '../../assets/img/skills/firebase.svg',
      ],
      descriptionEN: "Institutional website developed for a personal client who owns a restaurant; I handled the entire delivery, from architecture planning to production deployment, using modern technologies like HTML, CSS, JavaScript, and best practices for performance and SEO.",
      descriptionPT: "Projeto de um site institucional desenvolvido para um cliente pessoal, proprietário de um restaurante; fui responsável por toda a entrega, desde a definição da arquitetura até a publicação em produção, utilizando tecnologias modernas como HTML, CSS, JavaScript e boas práticas de performance e SEO."
    },
    {
      name: 'DSFront',
      img: '../../assets/img/companies/DSFront.webp',
      link: 'https://play.google.com/store/apps/details?id=br.com.helpper.dsfront',
      tech: [
        '../../assets/img/skills/ionic.svg',
        '../../assets/img/skills/angular.svg',
        '../../assets/img/skills/nodejs-icon.svg',
      ],
      descriptionEN: "Ionic app project for an investment company, where I contributed specifically to the development of some pages and the store deployment setup, without direct involvement in the full delivery of the product.",
      descriptionPT: "Projeto de um aplicativo em Ionic para uma empresa do setor de investimentos, no qual atuei pontualmente com a criação de algumas páginas e na configuração para publicação nas lojas, sem participação direta na entrega completa do produto."
    },
    {
      name: 'Plantão de Recursos',
      img: '../../assets/img/companies/plantao-de-recursos.webp',
      link: 'https://play.google.com/store/apps/details?id=com.medgrupo.recursos',
      tech: [
        '../../assets/img/skills/angular.svg',
        '../../assets/img/skills/ionic.svg',
      ],
      descriptionEN: "Development of a hybrid Ionic application focused on medical entrance exams. I participated from the architecture design through to final delivery on the app stores. Responsible for full frontend development, implementing dynamic pages with integration to RESTful APIs for real-time data exchange. Configured the push notification system and performed all necessary adaptations for deployment on Android, iOS, and web platforms. Delivered within 6 months, the project is a PWA (Progressive Web App), ensuring a seamless cross-platform experience. This was one of the most challenging and rewarding projects of my career.",
      descriptionPT: "Desenvolvimento de um aplicativo híbrido em Ionic focado em concursos de medicina. Participei desde a definição da arquitetura até a entrega final na loja. Fui responsável pelo desenvolvimento completo do frontend, implementando páginas dinâmicas com integração a APIs RESTful para troca de dados em tempo real. Realizamos a configuração do sistema de push notifications e todas as adaptações necessárias para publicação nas plataformas Android, iOS e web. O projeto, entregue em 6 meses, é uma PWA (Progressive Web App), garantindo experiência multiplataforma. Considero este um dos projetos mais desafiadores e enriquecedores da minha carreira."
    },
    {
      name: 'Medsoft Pro',
      img: '../../assets/img/companies/medsoft-pro.webp',
      link: 'https://play.google.com/store/apps/details?id=com.medgrupo.medsoft.pro',
      tech: ['../../assets/img/skills/ionic.svg', '../../assets/img/skills/angular.svg',],
      descriptionEN: "Development of additional modules for a medical courses platform already deployed in a production environment. My role focused on implementing complementary features, ensuring consistent integration with the existing architecture and adherence to the system’s quality standards.",
      descriptionPT: "Desenvolvimento de módulos adicionais para uma plataforma de cursos de medicina já em ambiente de produção. Minha atuação foi focada na implementação de funcionalidades complementares, garantindo integração consistente com a arquitetura existente e aderência aos padrões de qualidade do sistema."
    },

    {
      name: 'ClicaMed',
      img: '../../assets/img/companies/clicamedpac.webp',
      link: 'https://play.google.com/store/apps/details?id=br.com.helpper.clicamed.pacientes',
      tech: [
        '../../assets/img/skills/nodejs-icon.svg',
        '../../assets/img/skills/ionic.svg',
        '../../assets/img/skills/angular.svg',
      ],
      descriptionEN: "Development of an Ionic application for a medical company providing affordable consultations. I contributed to the development of scheduling and payment modules, among others. Additionally, I assisted in the app store publication process.",
      descriptionPT: "Desenvolvimento de um aplicativo em Ionic para uma empresa de médicos que oferecem consultas a preços acessíveis. Atuei no desenvolvimento de módulos de agendamento e pagamento, entre outros. Também contribuí no processo de publicação do aplicativo nas lojas oficiais."
    },
    {
      name: 'ClicaMed - Médicos',
      img: '../../assets/img/companies/clicamedmed.webp',
      link: 'https://play.google.com/store/apps/details?id=br.com.helpper.clicamed.medicos',
      tech: [
        '../../assets/img/skills/nodejs-icon.svg',
        '../../assets/img/skills/ionic.svg',
        '../../assets/img/skills/angular.svg',
      ],
      descriptionEN: "Development of an Ionic application for a medical company providing affordable consultations. I contributed to the development of scheduling and payment modules, among others. Additionally, I assisted in the app store publication process.",
      descriptionPT: "Desenvolvimento de um aplicativo em Ionic para uma empresa de médicos que oferecem consultas a preços acessíveis. Atuei no desenvolvimento de módulos de agendamento e pagamento, entre outros. Também contribuí no processo de publicação do aplicativo nas lojas oficiais."
    },
    {
      name: 'MGD Pneus',
      img: '../../assets/img/companies/mgd.webp',
      link: 'https://play.google.com/store/apps/details?id=br.com.helpper.mgd',
      tech: [
        '../../assets/img/skills/nodejs-icon.svg',
        '../../assets/img/skills/ionic.svg',
        '../../assets/img/skills/angular.svg',
      ],
      descriptionEN: "Initial development of an Ionic application focused on selling truck tires and parts. Responsible for designing the system architecture and developing the initial client and product modules. I was not involved in the final delivery phase of the project.",
      descriptionPT: "Desenvolvimento inicial de um aplicativo em Ionic voltado para venda de pneus e peças para caminhão. Fui responsável pela criação da arquitetura do sistema e pelo desenvolvimento dos primeiros módulos de clientes e produtos. Não participei da fase de entrega final do projeto."
    },
  ];

  public selectedLanguage = 'en';

  public formLogin: FormGroup;

  public loading = false;

  public sucesso = false;

  public error = false;

  constructor(
    private readonly _translate: TranslateService,
    private firestore: AngularFirestore,
    private __database: AngularFireDatabase,
    private __formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.formLogin = this.__formBuilder.group({
      name: [null, [Validators.required]],
      email: [null, [Validators.required]],
      phone: [null, [Validators.required]],
      message: [null, [Validators.required]],
    });
  }

  public selectLanguage(languega: string) {
    if (languega === 'en') {
      this._translate.setDefaultLang(languega);
      this.selectedLanguage = languega;
    } else {
      this._translate.setDefaultLang(languega);
      this.selectedLanguage = languega;
    }
  }

  public async onClick() {
    if (this.formLogin.invalid) {
      this.formLogin.markAllAsTouched(); // Exibe os erros nos campos
      return; // Não continua com o envio
    }

    if (this.formLogin.valid) {
      this.loading = true;
      this.__database
        .list('contato')
        .push(this.formLogin.value)
        .then((result: any) => {
          console.log(result.key);
          this.formLogin.reset();
          this.loading = false;
          this.sucesso = true;
          setTimeout(() => {
            this.sucesso = false;
          }, 3000);
        })
        .catch((error) => {
          console.log('error', error);
          this.loading = false;
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        });
    }
  }
}
